import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { useState, useEffect } from "react";
type InputDateInCardProps = {
  setLockDuration: Function;
  lockDuration: number;
  // onRef: any;
};

const InputDateInCard: React.FC<InputDateInCardProps> = ({
  lockDuration,
  setLockDuration,
}) => {
  const [value, setValue] = useState(dayjs(new Date()));
  useEffect(() => {
    if (lockDuration === 0) {
      setValue(dayjs(new Date()));
    } else {
      setValue(dayjs(new Date(lockDuration * 1000)));
    }
  }, [lockDuration]);
  return (
    <div className="flex items-start justify-between rounded-xl bg-primary-100 gap-2 p-4">
      <DatePicker
        className="date-picker"
        sx={{ width: "100%", fontSize: "20px" }}
        label=""
        value={value}
        autoFocus={false}
        onChange={(newValue) => {
          setValue(newValue!);

          setLockDuration(dayjs(newValue!).toDate().getTime() / 1000);
        }}
      />
    </div>
  );
};
export default InputDateInCard;
